'use strict';

var React = require('react');

var SvgActivitiesMajor = function SvgActivitiesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.76 9.882a.756.756 0 0 0-.008.179 7.25 7.25 0 1 0 14.495 0 .762.762 0 0 0-.006-.179 7.25 7.25 0 0 0-14.482 0Zm3.518-4.015a5.726 5.726 0 0 1 2.972-1.319v4.702h-1.77a7.471 7.471 0 0 0-1.202-3.383Zm-1.044 1.165a5.717 5.717 0 0 0-.897 2.218h1.634a5.98 5.98 0 0 0-.737-2.218Zm.737 3.718h-1.7c.078.9.363 1.742.808 2.476a5.98 5.98 0 0 0 .892-2.476Zm.092 3.691a5.73 5.73 0 0 0 3.187 1.51v-5.201h-1.77a7.468 7.468 0 0 1-1.417 3.691Zm9.6-5.191a5.718 5.718 0 0 0-.887-2.203 5.98 5.98 0 0 0-.73 2.203h1.617Zm-3.126 0a7.472 7.472 0 0 1 1.197-3.373 5.726 5.726 0 0 0-2.984-1.329v4.702h1.787Zm-1.787 1.5h1.787a7.47 7.47 0 0 0 1.41 3.681 5.731 5.731 0 0 1-3.197 1.52v-5.201Zm4.979 0a5.715 5.715 0 0 1-.8 2.461 5.975 5.975 0 0 1-.882-2.461h1.682Z"
  }));
};
SvgActivitiesMajor.displayName = "ActivitiesMajor";

exports.SvgActivitiesMajor = SvgActivitiesMajor;
